export const CREATE_MAPPING_RESET = 'CREATE_MAPPING_RESET';

export const CREATE_MAPPING_START = 'CREATE_MAPPING_START';
export const CREATE_MAPPING_SUCCESS = 'CREATE_MAPPING_SUCCESS';
export const CREATE_MAPPING_FAILURE = 'CREATE_MAPPING_FAILURE';
